import { createReducerContext } from '../../../../utils/create-reducer-context';
import { NewsSearchState, NewsSearchReducer, ACTION_TYPES } from './news-search-reducer';

const initialState: NewsSearchState = {
    parameters: { page: 0, pageSize: 25 },
    searchTrigger: 0,
    categories: [],
    drawer: { open: false },
};

const { Provider: NewsSearchProvider, useStateContext: useNewsSearchState, useDispatchContext: useNewsSearchDispatch } = createReducerContext('NewsSearch', NewsSearchReducer, initialState);

export { NewsSearchProvider, useNewsSearchState, useNewsSearchDispatch, ACTION_TYPES };
